import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    Snackbar,
    Alert,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Document, renameDocument } from "../../common/redux/documentsAction";
import { set } from "lodash";

interface Props {
    open: boolean;
    document: Document | null;
    onClose: () => void;
    onSuccess?: () => void;
}

const RenameModal: React.FC<Props> = ({
    open,
    document,
    onClose,
    onSuccess,
}) => {
    const [newName, setNewName] = useState("");
    const [error, setError] = useState<string | null>(null);

    const { t } = useTranslation();

    const rename = async (name: string) => {
        if (!document) return;
        try {
            await renameDocument(document.id, name);
            onSuccess?.();
            onClose();
        } catch (error) {
            setError(t("manageDocuments.error.rename"));
            console.error("Error renaming document:", error);
        }
    };

    useEffect(() => {
        if (open) setNewName(document?.name || "");
    }, [open, document?.name]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t("manageDocuments.rename.modal.title")}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label={t("documentsLabel.rename.document")}
                    fullWidth
                    variant="outlined"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    {t("button.modal.cancel")}
                </Button>
                <Button
                    onClick={() => rename(newName)}
                    disabled={!newName.trim()}
                    variant="contained"
                    color="primary"
                >
                    {t("button.modal.valid")}
                </Button>
            </DialogActions>

            <Snackbar
                open={!!error}
                autoHideDuration={3000}
                onClose={() => setError(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert
                    onClose={() => setError(null)}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    {error}
                </Alert>
            </Snackbar>
        </Dialog>
    );
};

export default RenameModal;
